import { register } from "async-ops";
import { callMvcApi } from "../../../call-web-api";
export const GET_AUDIT_GROUP_BY_ID = "GET_AUDIT_GROUP_BY_ID";

export const service = async (data) => {
  const options: object = {
    url: `/Api/ExternalAudit/GetAuditGroupById?auditGroupId=` + data.auditGroupId,
    method: "GET",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_AUDIT_GROUP_BY_ID, service, mock);
